import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateToString",
  standalone: true,
})
export class DateIntToStringPipe implements PipeTransform {
  transform(value: number): string {
    let year = Math.floor(value / 100);
    year = year % 100;
    const monthInt = value % 100;
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const month = months[monthInt - 1];
    return `${month} ${year}`;
  }
}
